var _circle, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevstatsinline = function SvgDevstatsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EB4748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.667 16c-.92 0-1.667.746-1.667 1.667v22.666c0 .92.746 1.667 1.667 1.667h34.666c.92 0 1.667-.746 1.667-1.667V17.667c0-.92-.746-1.667-1.667-1.667H14.667ZM22.5 32a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0zm13-2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m8-7a1 1 0 1 0-2 0v14a1 1 0 1 0 2 0zm-15 4a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1m0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 43h8v3h-8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 20,
    x: 22,
    y: 49,
    fill: "#fff",
    rx: 1.5,
    transform: "rotate(-90 22 49)"
  })));
};
export default SvgDevstatsinline;